import React, { useEffect, useRef } from 'react';
import MobileProductFeedback from './MobileProductFeedback';

export default function MobileProductSelection({ selection, loading, totalCount, onActions }) {
  const pageCheckbox = useRef(null);
  useEffect(() => {
    if (pageCheckbox.current)
      pageCheckbox.current.indeterminate = selection.someOnPage && !selection.allOnPage;
  }, [selection.someOnPage, selection.allOnPage]);
  const disabled = loading || selection.busy || !totalCount;
  return (
    <>
      <div className='mp-selection-tools'>
        <label className='mp-page-selection'>
          <input
            ref={pageCheckbox}
            type='checkbox'
            checked={selection.allOnPage}
            disabled={disabled}
            onChange={selection.togglePage}
            aria-label='Обрати сторінку'
          />
          <span>Обрати сторінку</span>
        </label>
        <button
          type='button'
          className='btn btn-sm btn-light mp-select-all-button'
          disabled={disabled}
          onClick={selection.selectMatching}
          aria-label={`Усі за фільтрами (${totalCount})`}
          title={`Обрати всі ${totalCount} товарів за поточними фільтрами`}
        >
          <i className='bi bi-check2-all mr-1' aria-hidden='true' />
          {selection.busy ? 'Обираємо…' : 'Обрати всі'}
        </button>
      </div>
      <MobileProductFeedback error={selection.error} />
      {selection.ids.length > 0 && (
        <div className='mp-selection-bar' aria-label='Дії з обраними товарами'>
          <div>
            <strong>Обрано: {selection.ids.length}</strong>
            <button
              type='button'
              disabled={selection.busy}
              onClick={selection.clear}
              aria-label='Скасувати вибір'
              title='Скасувати вибір'
            >
              <i className='bi bi-x-lg' aria-hidden='true' />
            </button>
          </div>
          <button
            type='button'
            className='btn btn-sm btn-dark'
            disabled={selection.busy}
            onClick={onActions}
          >
            Масові дії
          </button>
        </div>
      )}
    </>
  );
}
